import _ from 'lodash'

import { SCENE_MNG } from '@/api/apiModules'
export default {
  viewType: 'form',
  module: SCENE_MNG,
  callBackAction: 'CheckOsTypeForProduct',
  params: null,
  extraParams: null,
  formatData(data) {
    // if (data.desktopArch) {
    //   data.desktopArch = data.desktopArch.map(item => item.os + '-' + item.terminalType).join(',')
    // }
    if (data.recommendServer) {
      data.recommendServer = data.recommendServer.join(',')
    }
    if (data.recommendTerminal) {
      data.recommendTerminal = data.recommendTerminal.join(',')
    }
    if (data.recommendProduct) {
      data.recommendProduct = data.recommendProduct.join(',')
    }
    data.industryId = this.extraParams?.industryId
    return data
  },
  view: {
    labelWidth: '180px',
    width: '700px',
    title: '创建场景',
    labelPosition: 'right',
    content: [
      {
        $id: 'sceneName',
        $type: 'input',
        label: '场景名',
        rules: [
          {
            notEmpty: '场景名'
          }
        ]
      },
      {
        $id: 'sceneType',
        $type: 'select',
        label: '场景类型',
        $el: {
          filterable: true
        },
        $options: [
          {
            label: '业务场景',
            value: 'BUSI_SCENE'
          },
          {
            label: '部署场景',
            value: 'DEPLOY_SCENE'
          },
          {
            label: '安全场景',
            value: 'SECURITY_SCENE'
          },
          {
            label: '通用场景',
            value: 'COMMON_SCENE'
          },
          {
            label: '禁止场景',
            value: 'LIMIT_SCENE'
          }
        ],
        rules: [
          {
            notEmpty: 'type'
          }
        ]
      },
      {
        $id: 'sceneDesc',
        $type: 'input',
        $el: {
          type: 'textarea',
          rows: 5
        },
        label: '场景特征',
        rules: [
          {
            notEmpty: '场景特征'
          }
        ]
      },
      {
        $id: 'sceneDirId',
        $type: 'select',
        label: '场景目录',
        $el: {
          clearable: true,
          filterable: true
        },
        $options: 'sceneDir/findAllActive',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options
            .filter(item => item.industryId === this.rootView.views.extraParams?.industryId)
            .map(item => {
              return {
                value: item.id,
                label: item.sceneDirName
              }
            })

          return value ? value : ''
        },
        $enableWhen: {
          sceneType: function(currentValue, data, meta) {
            if (!currentValue || ['BUSI_SCENE'].includes(currentValue)) {
              return true
            }
          }
        }
      },
      {
        $id: 'instructions',
        $type: 'input',
        $el: {
          type: 'textarea',
          rows: 3
        },
        label: '注意事项'
      },
      {
        $id: 'solutionCase',
        $type: 'input',
        $el: {
          type: 'textarea',
          rows: 3
        },
        label: '应对措施',
        $enableWhen: {
          instructions: function(currentValue, data, meta) {
            // 如果有值设置
            if (currentValue) {
              return true
            }
          }
        }
      },
      {
        $id: 'desktopArch',
        $type: 'input',
        $el: {
          type: 'textarea',
          rows: 3
        },
        label: '终端模式',
        $enableWhen: {
          sceneType: function(currentValue, data, meta) {
            // 如果有值设置
            if (!['COMMON_SCENE', 'LIMIT_SCENE'].includes(currentValue)) {
              return true
            }
          }
        },
        rules: [
          {
            notEmpty: '终端模式'
          }
        ]
      },
      // {
      //   $id: 'desktopArch',
      //   $type: 'sky-desktop-arch',
      //   label: '终端模式',
      //   $enableWhen: {
      //     sceneType: function(currentValue, data, meta) {
      //       // 如果有值设置
      //       if (!['COMMON_SCENE', 'LIMIT_SCENE'].includes(currentValue)) {
      //         return true
      //       }
      //     }
      //   },
      //   rules: [
      //     {
      //       notEmpty: '终端模式'
      //     }
      //   ]
      // },
      {
        $id: 'desktopArch',
        $type: 'input',
        $el: {
          type: 'textarea',
          rows: 3
        },
        label: '终端模式',
        $enableWhen: {
          sceneType: function(currentValue, data, meta) {
            // 如果有值设置
            if (currentValue == 'COMMON_SCENE') {
              return true
            }
            return false
          }
        }
      },
      // {
      //   $id: 'desktopArch',
      //   $type: 'sky-desktop-arch',
      //   label: '终端模式',
      //   $enableWhen: {
      //     sceneType: function(currentValue, data, meta) {
      //       // 如果有值设置
      //       if (currentValue == 'COMMON_SCENE') {
      //         return true
      //       }
      //       return false
      //     }
      //   }
      // },
      {
        $id: 'desktopType',
        $type: 'select',
        label: '桌面模式',
        $el: {
          clearable: true
        },
        $enableWhen: {
          sceneType: function(currentValue, data, meta) {
            // 如果有值设置
            if (!['COMMON_SCENE', 'LIMIT_SCENE'].includes(currentValue)) {
              return true
            }
          }
        },
        rules: [
          {
            notEmpty: '桌面模式'
          }
        ],
        $options: 'global/enum/desktopType',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.label,
              label: item.label
            }
          })
          return value ? value : ''
        }
      },
      {
        $id: 'desktopType',
        $type: 'select',
        label: '桌面模式',
        $el: {
          clearable: true
        },
        $enableWhen: {
          sceneType: function(currentValue, data, meta) {
            // 如果有值设置
            if (currentValue == 'COMMON_SCENE') {
              return true
            }
          }
        },
        $options: 'global/enum/desktopType',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.label,
              label: item.label
            }
          })
          return value ? value : ''
        }
      },
      {
        $id: 'recommendServer',
        $type: 'select',
        label: '推荐服务器型号',
        $el: {
          clearable: true,
          filterable: true,
          multiple: true
        },
        $enableWhen: {
          sceneType: function(currentValue, data, meta) {
            // 如果有值设置
            if (!['COMMON_SCENE', 'LIMIT_SCENE'].includes(currentValue)) {
              return true
            }
          }
        },
        $options: 'server/findAllActive',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.serverName,
              label: item.serverName
            }
          })
          if (!value) {
            return []
          }
          return Array.isArray(value) ? value : value.split(',')
        },
        rules: [
          {
            notEmpty: '服务器型号'
          }
        ]
      },
      {
        $id: 'recommendServer',
        $type: 'select',
        label: '推荐服务器型号',
        $el: {
          clearable: true,
          filterable: true,
          multiple: true
        },
        $enableWhen: {
          sceneType: function(currentValue, data, meta) {
            // 如果有值设置
            if (currentValue == 'COMMON_SCENE') {
              return true
            }
          }
        },
        $options: 'server/findAllActive',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.serverName,
              label: item.serverName
            }
          })
          if (!value) {
            return []
          }
          return Array.isArray(value) ? value : value.split(',')
        }
      },
      {
        $id: 'recommendTerminal',
        $type: 'select',
        label: '推荐终端型号',
        $el: {
          clearable: true,
          filterable: true,
          multiple: true
        },
        $enableWhen: {
          sceneType: function(currentValue, data, meta) {
            // 如果有值设置
            if (!['COMMON_SCENE', 'LIMIT_SCENE'].includes(currentValue)) {
              return true
            }
          }
        },
        $options: 'terminal/findAllActive',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.id,
              label: item.model
            }
          })
          if (!value) {
            return []
          }

          return Array.isArray(value) ? value : value.split(',')
        },
        rules: [
          {
            notEmpty: '终端型号'
          }
        ]
      },
      {
        $id: 'recommendTerminal',
        $type: 'select',
        label: '推荐终端型号',
        $el: {
          clearable: true,
          filterable: true,
          multiple: true
        },
        $enableWhen: {
          sceneType: function(currentValue, data, meta) {
            // 如果有值设置
            if (currentValue == 'COMMON_SCENE') {
              return true
            }
          }
        },
        $options: 'terminal/findAllActive',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.id,
              label: item.model
            }
          })
          if (!value) {
            return []
          }
          return Array.isArray(value) ? value : value.split(',')
        }
      },
      {
        $id: 'relationSceneIdList',
        $type: 'sky-relation-option',
        label: '联动选择场景',
        $el: { disabled: false, multiple: true },
        actions: {
          nativeOn: {
            click: 'RelationScene'
          }
        },
        $enableWhen: {
          sceneType: function(currentValue, data, meta) {
            // 如果有值设置
            if (!['LIMIT_SCENE'].includes(currentValue)) {
              return true
            }
          }
        }
      },
      {
        $id: 'recommendProduct',
        $type: 'select',
        label: '版本支持',
        $el: {
          clearable: true,
          filterable: true,
          multiple: true
        },
        // actions: {
        //   on: {
        //     updateValue: 'CheckOsTypeForProduct'
        //   }
        // },
        $options: 'product/findAllActive',
        dataType: 'asyn',
        format: function(meta, value) {
          const _options = _.isArray(meta.$options) && meta.$options.length > 0 ? meta.$options : []
          meta.$options = _options.map(item => {
            return {
              value: item.id,
              label: item.productVersion
            }
          })
          if (!value) {
            return []
          }
          return Array.isArray(value) ? value : value.split(',')
        },
        $enableWhen: {
          sceneType: function(currentValue, data, meta) {
            // 如果有值设置
            if (!['LIMIT_SCENE'].includes(currentValue)) {
              return true
            }
          }
        },
        rules: [
          {
            notEmpty: '版本支持'
          }
        ]
      },
      {
        $id: 'customerProblem',
        $type: 'input',
        $el: {
          type: 'textarea',
          rows: 5
        },
        label: '客户问题',
        rules: [
          {
            notEmpty: '客户问题'
          }
        ]
      },
      {
        $id: 'bindCollectSoft',
        $type: 'radio-group',
        label: '要求绑定采集软件报告',
        $default: false,
        $options: [
          {
            label: '是',
            value: true
          },
          {
            label: '否',
            value: false
          }
        ],
        $enableWhen: {
          sceneType: function(currentValue, data, meta) {
            if (!['LIMIT_SCENE'].includes(currentValue)) {
              return true
            }
          }
        }
      }
    ]
  }
}
